// Define LibraryIDs and guard clause
export const libraryIDs = [
    'vbp',
    'bkw',
    'flevo',
    'twente',
    'dnb',
    'aanzet',
    'rdam'
];
export const isLibraryID = (id)=>libraryIDs.includes(id);
export const getConfig = (configs)=>()=>{
        const libraryID = window.library;
        if (!isLibraryID(libraryID)) throw new TypeError(`Library ID must be one of: ${libraryIDs.join(', ')}`);
        return configs[libraryID];
    };
